import React from 'react';

import { useMediaQuery } from '@mui/material';
import classNames from 'classnames/bind';

import { BREAK_POINTS } from '@common/constants/breackpoints';

import { locale } from './locale';

import styles from './EnvironmentNotification.module.css';

const cn = classNames.bind(styles);

const envLocale = locale.environments[process.env.ENVIRONMENT];

type Props = {
  className?: string;
};

export function EnvironmentNotification({ className }: Props) {
  const isMobile = useMediaQuery(`(max-width: ${BREAK_POINTS.screenMobileMax})`);

  if (!envLocale) {
    return null;
  }

  return (
    <div className={cn('root', className)}>
      {isMobile ? (
        envLocale?.mobile
      ) : (
        <>
          {envLocale?.desktop}
          {envLocale?.desktop_sub && (
            <>
              <br />
              <span className={cn('sub')}>{envLocale?.desktop_sub}</span>
            </>
          )}
        </>
      )}
    </div>
  );
}
